export const BMI_THRESHOLD = 30;
export const AGE_THRESHOLD = 60;
export const HEREDITY_AGE_THRESHOLD = 50;
export const TEST_ID = window.location.pathname.replace('/', '');
export const APP_BASE = TEST_ID;
export const PHONE_BOOKING_OFFER = ['apotek-hjartat', 'feelgood'];
